import { render, staticRenderFns } from "./VAddress.vue?vue&type=template&id=57e9f084&scoped=true&"
import script from "./VAddress.vue?vue&type=script&lang=js&"
export * from "./VAddress.vue?vue&type=script&lang=js&"
import style0 from "./VAddress.vue?vue&type=style&index=0&id=57e9f084&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e9f084",
  null
  
)

export default component.exports